import React from "react";

const Nav = () => {
    return (
        <div className="  nav  text-gray-900 text-4xl sm:text-5xl  font-black max-w-6xl   lg:max-w-7xl pt-10 pl-5 sm:pl-14 md:pl-28 lg:pl-20 m-auto ">
            Diwakar Here
        </div>
    );
};

export default Nav;
